import type { Brand } from './types'
import { OPTIONAL_BRAND_COLOR_KEYS } from './color-keys'

const BRAND_KEY_SET: Record<keyof Brand, true> = {
  name: true,
  primary: true,
  primaryFg: true,
  accent: true,
  accentFg: true,
  surface: true,
  sidebar: true,
  primaryDark: true,
  primaryFgDark: true,
  accentDark: true,
  accentFgDark: true,
  surfaceDark: true,
  sidebarDark: true,
  logoUrlLight: true,
  logoUrlDark: true,
  logoAspect: true,
  fontHeading: true,
  fontBody: true,
}

export const BRAND_KEYS = Object.keys(BRAND_KEY_SET) as (keyof Brand)[]

export function decodeBrand(value: unknown): Brand {
  if (typeof value !== 'object' || value === null || Array.isArray(value))
    throw new Error('Malformed whitelabel config')
  const record = value as Record<string, unknown>
  const brand: Partial<Record<keyof Brand, string>> = {}
  for (const key of BRAND_KEYS) {
    const v = record[key]
    if (OPTIONAL_BRAND_COLOR_KEYS.has(key) && (v === undefined || v === null)) continue
    if (typeof v !== 'string') throw new Error(`Expected a string for "${key}"`)
    brand[key] = v
  }
  return brand as Brand
}

export function tryDecodeBrand(value: unknown): Brand | null {
  try {
    return decodeBrand(value)
  } catch {
    return null
  }
}
